import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "freelancer-price-details" }
const _hoisted_2 = { class: "freelancer-price-details__title" }
const _hoisted_3 = { class: "freelancer-price-details__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$msg('project.submission.header.shortlist.price.tooltip.title')), 1),
    _createElementVNode("dl", _hoisted_3, [
      _createElementVNode("dt", null, _toDisplayString(_ctx.detailedPriceFormatter.format(_ctx.profile.price.ht)), 1),
      _createElementVNode("dd", null, _toDisplayString(_ctx.$msg('project.submission.header.shortlist.price.tooltip.ht')), 1),
      _createElementVNode("dt", null, _toDisplayString(_ctx.detailedPriceFormatter.format(_ctx.profile.price.details.fees.value)), 1),
      _createElementVNode("dd", null, _toDisplayString(_ctx.isRepatriationText), 1),
      _createElementVNode("dt", null, _toDisplayString(_ctx.detailedPriceFormatter.format(_ctx.profile.price.details.total)), 1),
      _createElementVNode("dd", null, _toDisplayString(_ctx.$msg('project.submission.header.shortlist.price.tooltip.total')), 1)
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$msg('project.submission.header.shortlist.price.tooltip.label')), 1)
  ]))
}